export default function mask() {  
    if(document.querySelector(".phone") || document.querySelector("#billing_phone")) {
        $(".phone").mask("(00) 00000-0000");
        $("#billing_phone").mask("(00) 00000-0000");
    } 
}